import { IConfigurationItemVM } from "../../models";

const ConfigurationItems: IConfigurationItemVM[] = [
    {
        name: 'Allergy Reaction',
        entityTypeName: 'AllergyReactionMaster',
        identityTypeName: 'Int32',
        identityPropName: 'reactionId',
        displayTypeName: 'reactionName',
    },
    {
        name: 'Appointment Reason',
        entityTypeName: 'AppointmentReasonMaster',
        identityTypeName: 'Int32',
        identityPropName: 'reasonId',
        displayTypeName: 'reason',
    },
    {
        name: 'Appointment Status',
        entityTypeName: 'AppointmentStatusMaster',
        identityTypeName: 'Int32',
        identityPropName: 'statusId',
        displayTypeName: 'statusName',
    },
    {
        name: 'Barcode Output',
        entityTypeName: 'BarcodeOutputMaster',
        identityTypeName: 'Int32',
        identityPropName: 'barcodeOutputId',
        displayTypeName: 'barcodeOutputName',
    },
    {
        name: 'Barcode Type',
        entityTypeName: 'BarcodeTypeMaster',
        identityTypeName: 'Int32',
        identityPropName: 'barcodeTypeId',
        displayTypeName: 'barcodeTypeName',
    },
    {
        name: 'Communication',
        entityTypeName: 'CommunicationMaster',
        identityTypeName: 'Int32',
        identityPropName: 'communicationId',
        displayTypeName: 'communicationName',
    },
    {
        name: 'Condition',
        entityTypeName: 'ConditionMaster',
        identityTypeName: 'Int32',
        identityPropName: 'conditionId',
        displayTypeName: 'conditionName',
    },
    {
        name: 'Doc Type',
        entityTypeName: 'DocTypeMaster',
        identityTypeName: 'Int32',
        identityPropName: 'docTypeId',
        displayTypeName: 'docTypeName',
    },
    {
        name: 'Document Label',
        entityTypeName: 'DocumentLabelMaster',
        identityTypeName: 'Int32',
        identityPropName: 'labelId',
        displayTypeName: 'labelName',
    },
    {
        name: 'Education',
        entityTypeName: 'EducationMaster',
        identityTypeName: 'Int32',
        identityPropName: 'educationId',
        displayTypeName: 'educationName',
    },
    {
        name: 'Ethnicity',
        entityTypeName: 'EthnicityMaster',
        identityTypeName: 'Int32',
        identityPropName: 'ethnicityId',
        displayTypeName: 'ethnicityName',
    },
    {
        name: 'Gender Identity',
        entityTypeName: 'GenderIdentityMaster',
        identityTypeName: 'Int32',
        identityPropName: 'genderIdentityId',
        displayTypeName: 'genderIdentityName',
    },
    {
        name: 'Gender',
        entityTypeName: 'GenderMaster',
        identityTypeName: 'Int32',
        identityPropName: 'genderId',
        displayTypeName: 'genderName',
    },
    {
        name: 'Kit Category',
        entityTypeName: 'KitCategoryMaster',
        identityTypeName: 'Int32',
        identityPropName: 'kitCategoryId',
        displayTypeName: 'kitCategoryName',
    },
    {
        name: 'Kit Title',
        entityTypeName: 'KitTitleMaster',
        identityTypeName: 'Int32',
        identityPropName: 'kitTitleId',
        displayTypeName: 'kitTitleName',
    },
    {
        name: 'Kit Type',
        entityTypeName: 'KitTypeMaster',
        identityTypeName: 'Int32',
        identityPropName: 'kitTypeId',
        displayTypeName: 'kitTypeName',
    },
    {
        name: 'Lab Category',
        entityTypeName: 'LabCategoryMaster',
        identityTypeName: 'Int32',
        identityPropName: 'labCategoryId',
        displayTypeName: 'categoryName',
    },
    {
        name: 'Language',
        entityTypeName: 'LanguageMaster',
        identityTypeName: 'Int32',
        identityPropName: 'languageId',
        displayTypeName: 'languageName',
    },
    {
        name: 'Marital Status',
        entityTypeName: 'MaritalStatusMaster',
        identityTypeName: 'Int32',
        identityPropName: 'statusId',
        displayTypeName: 'statusName',
    },
    {
        name: 'Occupation',
        entityTypeName: 'OccupationMaster',
        identityTypeName: 'Int32',
        identityPropName: 'occupationId',
        displayTypeName: 'occupationName',
    },
    {
        name: 'Race',
        entityTypeName: 'RaceMaster',
        identityTypeName: 'Int32',
        identityPropName: 'raceId',
        displayTypeName: 'raceName',
    },
    {
        name: 'Relation',
        entityTypeName: 'RelationMaster',
        identityTypeName: 'Int32',
        identityPropName: 'relationId',
        displayTypeName: 'relationName',
    },
    {
        name: 'Severity',
        entityTypeName: 'SeverityMaster',
        identityTypeName: 'Int32',
        identityPropName: 'severityId',
        displayTypeName: 'severityName',
    },
    {
        name: 'Sexual Orientation',
        entityTypeName: 'SexualOrientationMaster',
        identityTypeName: 'Int32',
        identityPropName: 'sexualOrientationId',
        displayTypeName: 'sexualOrientationName',
    },
    {
        name: 'Shipment Status',
        entityTypeName: 'ShipmentStatusMaster',
        identityTypeName: 'Int32',
        identityPropName: 'shipmentStatusId',
        displayTypeName: 'shipmentStatusName',
    },
    {
        name: 'Shipper',
        entityTypeName: 'ShipperMaster',
        identityTypeName: 'Int32',
        identityPropName: 'shipperId',
        displayTypeName: 'shipperName',
    },
    {
        name: 'Speciality',
        entityTypeName: 'SpecialityMaster',
        identityTypeName: 'Int32',
        identityPropName: 'specialityId',
        displayTypeName: 'specialityName',
    },
    {
        name: 'Specimen Type',
        entityTypeName: 'SpecimenTypeMaster',
        identityTypeName: 'Int32',
        identityPropName: 'specimenTypeId',
        displayTypeName: 'specimenTypeName',
    },
    {
        name: 'Tax Type',
        entityTypeName: 'TaxTypeMaster',
        identityTypeName: 'Int32',
        identityPropName: 'taxId',
        displayTypeName: 'taxName',
    },
    {
        name: 'Title',
        entityTypeName: 'TitleMaster',
        identityTypeName: 'Int32',
        identityPropName: 'titleId',
        displayTypeName: 'titleName',
    },
];

export { ConfigurationItems };